import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidDirectionIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14.3 14.8 12 17.1l-2.3-2.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3 3c.2.2.4.3.7.3.3 0 .5-.1.7-.3l3-3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0Zm-4.6-4.6L12 7.9l2.3 2.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-3-3c-.4-.4-1-.4-1.4 0l-3 3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0Z"/>
  </SvgIcon>
}

export default SolidDirectionIcon
